
<nav class="header-nav">
	<span class="navbar-logo">
		<img [src]="logo" height="20" alt="">
	</span>
	<span class="navbar-right">

		<!-- Only for development and deployment purpose - it should not be shown for end user !!! -->
		<span style="display: none">App version: {{appVersion}}</span>

		<ng-content></ng-content>

	</span>
</nav>
